import { ElementCoordinate } from '../enums/enums';

interface WindowCoordinatePoint {
    x: number,
    y: number
}

class WindowCoordinates {
    domElRectangle: DOMRect;
    position: ElementCoordinate;
    private _point: WindowCoordinatePoint;
    private _scrollingElement: HTMLElement;
    constructor(domElRectangle: DOMRect, position: ElementCoordinate) {
        this.domElRectangle = domElRectangle;
        this.position = position;
        this._point = {x:0, y:0};
        this._scrollingElement = document.getElementsByTagName("main")[0];
        this.setPoint();
    }

    getPoint() : WindowCoordinatePoint{
        return this._point;
    }

    setPoint(){
        const left = this.domElRectangle.left;
        const top = this.domElRectangle.top;
        const width = this.domElRectangle.width;
        const height = this.domElRectangle.height;
        switch (this.position) {
            case "UPPER_LEFT":
                this._point = {
                    x: left + this._scrollingElement.scrollLeft,
                    y: top + this._scrollingElement.scrollTop
                };
                break;
            case "UPPER_CENTER":
                this._point = {
                    x: left + width / 2 + this._scrollingElement.scrollLeft,
                    y: top + this._scrollingElement.scrollTop
                };
                break;
            case "UPPER_RIGHT":
                this._point = {
                    x: left + width + this._scrollingElement.scrollLeft,
                    y: top + this._scrollingElement.scrollTop
                };
                break;
            case "CENTER_LEFT":
                this._point = {
                    x: left + this._scrollingElement.scrollLeft,
                    y: top + height / 2 + this._scrollingElement.scrollTop
                };
                break;
            case "CENTER":
                this._point = {
                    x: left + width / 2 + this._scrollingElement.scrollLeft,
                    y: top + height / 2 + this._scrollingElement.scrollTop
                };
                break;
            case "CENTER_RIGHT":
                this._point = {
                    x: left + width + this._scrollingElement.scrollLeft,
                    y: top + height / 2 + this._scrollingElement.scrollTop
                };
                break;
            case "LOWER_LEFT":
                this._point = {
                    x: left + this._scrollingElement.scrollLeft,
                    y: top + height + this._scrollingElement.scrollTop
                };
                break;
            case "LOWER_CENTER":
                this._point = {
                    x: left + width / 2 + this._scrollingElement.scrollLeft,
                    y: top + height + this._scrollingElement.scrollTop
                };
                break;
            case "LOWER_RIGHT":
                this._point = {
                    x: left + width + this._scrollingElement.scrollLeft,
                    y: top + height + this._scrollingElement.scrollTop
                };
                break;
        }
    }
}

export default WindowCoordinates;